import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";

import { DealersAndLocationsDropdown, Dropdown } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { DEALER_DOCUMENTATION_CATEGORIES, ROLES } from "models";
import "modules/DealerDocumentations/components/DealerDocumentationsFilters/DealerDocumentationsFilters.scss";
import { setDealerDocumentationsFilters, useDealerDocumentationsFilters } from "modules/DealerDocumentations/hooks";
import { enumToDropdownOptions } from "utils/common";

export const DealerDocumentationsFilters = () => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();
  const { dealer_ids, dealer_location_ids, visible_to_mechanic, category_id } = useDealerDocumentationsFilters();

  const categoryOptions = enumToDropdownOptions({ enumObj: DEALER_DOCUMENTATION_CATEGORIES, t });
  const canSelectDealers = !!(user?.role_id !== ROLES.Mechanic);

  return (
    <>
      <DealersAndLocationsDropdown
        values={{ dealerIds: dealer_ids, locationIds: dealer_location_ids }}
        handleOnChange={({ dealerIds, locationIds }) => setDealerDocumentationsFilters({ dealer_ids: dealerIds, dealer_location_ids: locationIds })}
        allowSelectDealers={canSelectDealers}
        allowSelectAllDealers={canSelectDealers}
      />
      <Dropdown
        noResultsMessage={t("v8_no_categories", "No categories")}
        placeholder={t("v8_select_category", "Select a category")}
        fluid
        selection
        clearable
        value={category_id}
        options={categoryOptions}
        selectOnBlur={false}
        onChange={category_id => setDealerDocumentationsFilters({ category_id })}
      />
      <div className="DealerDocumentationsFilters">
        <span> {t("v8_visible_to_mechanic", "Visible to Mechanic")} </span>
        <Checkbox
          toggle
          className="checkbox-is-visible"
          checked={visible_to_mechanic}
          onChange={(_, { checked }) => setDealerDocumentationsFilters({ visible_to_mechanic: !!checked })}
        />
      </div>
    </>
  );
};
